var _excluded = ["children", "size"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from 'react';
import styled from 'styled-components';
import getTextStyles from "../../../utils/getTextStyles/getTextStyles.js";
var halfSpacing = 'calc(var(--spacing-1) / 2)';
export var variantPadding = {
  small: "calc(var(--spacing-1) + ".concat(halfSpacing, ") var(--spacing-1) ").concat(halfSpacing),
  medium: "calc(var(--spacing-2) + ".concat(halfSpacing, ") var(--spacing-2) ").concat(halfSpacing),
  large: 'var(--spacing-3) var(--spacing-3) var(--spacing-2)'
};
// Match EyebrowText styles
var StyledLiAsEyebrow = styled.li.withConfig({
  componentId: "CL__sc-6cpc3w-0"
})(["", ";color:var(--gray-5);cursor:default;list-style:none;padding:", ";"], getTextStyles.eyebrowText(), _ref => {
  var {
    $size
  } = _ref;
  return variantPadding[$size];
});
var DropdownMenuHeading = _ref2 => {
  var {
      children,
      size = 'medium'
    } = _ref2,
    props = _objectWithoutProperties(_ref2, _excluded);
  return /*#__PURE__*/React.createElement(StyledLiAsEyebrow, _extends({
    role: "heading",
    $size: size
  }, props), children);
};
export default DropdownMenuHeading;